export enum BenefitsResource {
    getMember = '/v2/benefitManagement/employees/:employeeId/simplyBenefits/members/show',
    getNewMemberToken = '/v2/benefitManagement/employees/:employeeId/simplyBenefits/members/token',
    getClass = '/v2/benefitManagement/simplyBenefits/classes/:classId',
    getClasses = '/v2/benefitManagement/simplyBenefits/classes',
    getDivision = '/v2/benefitManagement/simplyBenefits/divisions/:divisionId',
    getDivisions = '/v2/benefitManagement/simplyBenefits/divisions',
}
